module.exports = __webpack_public_path__ + "img/qr_icon.f66a5177.svg";